import { FaInstagram, FaFacebookF, FaYoutube, FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaDumbbell } from "react-icons/fa";
import { Link } from "react-router-dom";

export default function Footer() {

    const currentYear = new Date().getFullYear();
    const quickLinks = [
        { name: "About Me", path: "/user/About" },
        { name: "Programs", path: "/user/Programs" },
        { name: "Calorie Calculator", path: "/user/Calorie" },
        { name: "BMI Calculator", path: "/user/Bmi" },
        { name: "Protein Calculator", path: "/user/ProteinCalculator" }
    ];

    return (
        <footer>
            <section className="footer-cta position-relative overflow-hidden">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 ">
                            <p className="text-danger fw-bold text-uppercase mt-3">Ready To Start?</p>
                            <h1 className="text-white fw-bold">
                                Ready To Transform
                                <br />
                                <span className="text-danger">Your Body?</span>
                            </h1>
                            <p className="text-light mb-3">Take the first step today and let's build the best version of you.</p>
                            <div className="d-flex flex-wrap gap-3">
                                <Link to="/user/Contact">
                                    <button className="btn btn-danger px-2 py-1">
                                        📅 Book Free Consultation
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="py-3" style={{ background: "#0f1117", }}>
                <div className="container">
                    <div className="row g-3">
                        <div className="col-lg-3 col-12">
                            <h3 className="text-white fw-bold">
                                <FaDumbbell className="text-danger me-2" /> The Fitness Expert
                            </h3>
                            <p className="text-secondary"> Helping busy professionals lose fat, gain muscle and build confidence through sustainable coaching.</p>
                            <div className="d-flex align-items-center justify-content-start">
                                <Link href="https://www.instagram.com/harmanwellnesswarrior?igsh=MXhjZ2tpYXcyaXB5ag==" className=" btn-sm text-secondary mb-2">
                                    <FaInstagram size={20} />
                                </Link>
                                <p className="text-secondary text-center mt-2 ms-2">Follow us on Instagram</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-6">
                            <h4 className="text-white">Quick Links</h4>
                            <ul className="list-unstyled">
                                {quickLinks.map((link, index) => (
                                    <li className="mb-0" key={index}>
                                        <Link to={link.path} className="footer-link text-decoration-none text-secondary">
                                            {link.name}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="col-lg-3 col-6">
                            <h4 className="text-white">Programs</h4>
                            <ul className="list-unstyled">
                                <li className="text-secondary">Fat Loss Program</li>
                                <li className="text-secondary">Muscle Building</li>
                                <li className="text-secondary">Body Recomposition</li>
                                <li className="text-secondary">Nutrition Coaching</li>
                                <li className="text-secondary">Online Training</li>
                            </ul>
                        </div>
                        <div className="col-lg-3 col-12">
                            <h4 className="text-white">Contact</h4>
                            <div className="text-secondary">
                                <FaPhoneAlt className="me-2" />
                                +91 98768 57579
                            </div>
                            <div className="text-secondary">
                                <FaEnvelope className="me-2" />
                                harmanverma5692@gmail.com
                            </div>
                            <div className="text-secondary">
                                <FaMapMarkerAlt className="me-2" />
                                Ludhiana, Punjab
                            </div>
                        </div>
                    </div>
                    <hr className="border-secondary my-2" />
                    <div className="d-flex flex-wrap justify-content-between align-items-center">
                        <p className="text-secondary mb-0">
                            © {currentYear} BY SOCIALBUZDYNAMICS. All Rights Reserved.
                        </p>
                        <div className="d-flex">
                            <p className="footer-link text-decoration-none text-secondary me-3"> Privacy Policy</p>
                            <p className="footer-link text-decoration-none text-secondary">Terms & Conditions</p>
                        </div>
                    </div>
                </div>
            </section>
        </footer>
    );
}